
const digest = '1b6aa5791afe24340ffcdaf0ddba35b8dff6edc65afb7fec8a0e74f0c93db816';
const classes = {"item":"_item_1h5iv_1","value":"_value_1h5iv_6"};
const css = `._item_1h5iv_1 {
  display: flex;
  flex-direction: row;
  gap: 12px;
}
._item_1h5iv_1 ._value_1h5iv_6 {
  font-size: 14px;
  font-family: Rubik, "sans-serif";
  font-weight: 500;
  color: #3e3f42;
  min-width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  